
(function() {
  /* Predictive search */
  /* Use theme predictive search as the fallback when Boost Instant Search is unavailable. */
  var searchWrap = document.querySelector('[data-jz-search]');
  var searchInput = document.querySelector('[data-jz-search-input]');
  var searchResults = document.querySelector('[data-jz-search-results]');
  var searchTimeout = null;
  var searchAbort = null;
  var searchRevision = 0;
  var searchUrl = window.jsqSearchCfg.u;
  var searchCurrency = window.jsqSearchCfg.c;
  var fromPrice = window.jsqSearchCfg.p;

  function cancelSearch() {
    clearTimeout(searchTimeout);
    searchRevision++;
    if (searchAbort) searchAbort.abort();
    searchAbort = null;
  }
  function searchPrice(product) {
    var value = Number(product.price);
    if (!Number.isFinite(value)) return '';
    var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:searchCurrency}).format(value);
    return Number(product.price_min) < Number(product.price_max) ? fromPrice.replace('__PRICE__', formatted) : formatted;
  }

  if (!searchInput || !searchResults) return;

  function escHTML(s) {
    return String(s).replace(/[&<>"']/g, function(m) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
    });
  }

  function hideResults() {
    cancelSearch();
    searchResults.innerHTML = '';
    jzActiveIdx = -1;
    searchResults.hidden = true;
    searchInput.setAttribute('aria-expanded', 'false');
    searchInput.removeAttribute('aria-activedescendant');
  }
  function showResults(html) {
    searchResults.innerHTML = html;
    searchResults.dataset.jsqQuery = searchInput.value.trim();
    searchResults.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
    jzMark();
    var n = jzOpts().length;
    jzAnnounce(n ? n + (n === 1 ? ' suggestion. ' : ' suggestions. ') + 'Use arrow keys to review.' : 'No results.');
  }

  function runSearch(q) {
      if (/^(?:24[\s\-\/]*(?:6|six)|twenty\s+four\s+six)(?:\s+player)?$/i.test(q)) q = '24Six';
    var revision = searchRevision;
    searchAbort = new AbortController();
    var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
              '&resources%5Btype%5D=product%2Ccollection%2Carticle' +
              '&resources%5Blimit%5D=6' +
              '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
              /* SEARCH_SKU_FIX 2026-05-03, match SKU/code in body so item numbers like 'c805' surface in dropdown */
              '&resources%5Boptions%5D%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Cvariants.title%2Cvariants.sku%2Cbody%2Cvariants.barcode';
    fetch(url, { signal: searchAbort.signal, headers: { 'Accept': 'application/json' } })
      .then(function(r) { if (!r.ok) throw new Error('Search request failed'); return r.json(); })
      .then(function(data) {
        if (revision !== searchRevision) return;
        var r = (data && data.resources && data.resources.results) || {};
        var products = r.products || [];
          if (q === '24Six') {
            products.sort(function(a, b) {
              var ap = /24six.*solo4.*player/i.test(a.title || '') ? 0 : 1;
              var bp = /24six.*solo4.*player/i.test(b.title || '') ? 0 : 1;
              return ap - bp;
            });
          }
        var collections = r.collections || [];
        var articles = r.articles || [];
        if (!products.length && !collections.length && !articles.length) {
          hideResults();
          jzAnnounce('No results for ' + q);
          return;
        }
        var html = '';
        if (products.length) {
          html += '<p class="jz-hdr__results-section">Products</p>';
          products.forEach(function(p) {
            html += '<a class="jz-hdr__result" href="' + escHTML(p.url || '#') + '">' +
              (p.image ? '<img class="jz-hdr__result-img" src="' + escHTML(p.image) + '" alt="" role="presentation" loading="lazy">' : '<span class="jz-hdr__result-img"></span>') +
              '<span class="jz-hdr__result-body">' +
              '<p class="jz-hdr__result-title">' + escHTML(p.title || '') + '</p>' +
              '<p class="jz-hdr__result-meta">' +
                (p.vendor ? '<span>' + escHTML(p.vendor) + '</span>' : '') +
                (p.price ? '<strong>' + escHTML(searchPrice(p)) + '</strong>' : '') +
              '</p>' +
              '</span>' +
              '</a>';
          });
        }
        if (collections.length) {
          html += '<p class="jz-hdr__results-section">Collections</p>';
          collections.forEach(function(c) {
            html += '<a class="jz-hdr__result" href="' + escHTML(c.url || '#') + '">' +
              '<span class="jz-hdr__result-img" style="display:grid;place-items:center;" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9C7C44" stroke-width="1.7"><path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg></span>' +
              '<span class="jz-hdr__result-body">' +
              '<p class="jz-hdr__result-title">' + escHTML(c.title || '') + '</p>' +
              '</span>' +
              '</a>';
          });
        }
        if (articles.length) {
          html += '<p class="jz-hdr__results-section">Articles</p>';
          articles.forEach(function(a) {
            html += '<a class="jz-hdr__result" href="' + escHTML(a.url || '#') + '">' +
              '<span class="jz-hdr__result-img" style="display:grid;place-items:center;" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9C7C44" stroke-width="1.7"><path d="M2 4h7a3 3 0 0 1 3 3v13a2.5 2.5 0 0 0-2.5-2.5H2z"/><path d="M22 4h-7a3 3 0 0 0-3 3v13a2.5 2.5 0 0 1 2.5-2.5H22z"/></svg></span>' +
              '<span class="jz-hdr__result-body">' +
              '<p class="jz-hdr__result-title">' + escHTML(a.title || '') + '</p>' +
              '</span>' +
              '</a>';
          });
        }
        html += '<a class="jz-hdr__results-viewall" href="' + escHTML(searchUrl) + '?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + escHTML(q) + '&rdquo; →</a>';
        showResults(html);
      })
      .catch(function(err) {
        if (revision !== searchRevision || (err && err.name === 'AbortError')) return;
        showResults('<p class="jz-hdr__results-empty">Search unavailable. <a href="' + escHTML(searchUrl) + '?q=' + encodeURIComponent(q) + '">Open full search →</a></p>');
      });
  }

  searchInput.addEventListener('input', function() {
    var q = this.value.trim();
    hideResults();
    if (q.length < 2) return;
    searchTimeout = setTimeout(function() { runSearch(q); }, 180);
  });
  searchInput.addEventListener('focus', function() {
    var q = this.value.trim();
    if (!searchResults.hidden && searchResults.dataset.jsqQuery === q) return;
    hideResults();
    if (q.length >= 2) searchTimeout = setTimeout(function() { runSearch(q); }, 180);
  });
  if (searchWrap) {
    var submitButton = searchWrap.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('focus', function() { jzMark(); });
      submitButton.addEventListener('pointerdown', function() { jzMark(); });
    }
    searchWrap.addEventListener('submit', function(e) {
      var options = jzOpts();
      var selected = !searchResults.hidden && searchResults.dataset.jsqQuery === searchInput.value.trim() && jzActiveIdx > -1 && options[jzActiveIdx];
      if (selected) { e.preventDefault(); e.stopImmediatePropagation(); window.location.assign(selected.href); }
      hideResults();
    }, true);
  }
  document.addEventListener('click', function(e) {
    if (searchWrap && !searchWrap.contains(e.target)) hideResults();
  });
  /* SPRINT4.5: keyboard support, arrows move through suggestions, Enter opens, counts announced */
  var jzActiveIdx = -1;
  function jzAnnounce(msg) {
    var st = document.getElementById('status-announcement');
    if (st) { st.textContent = ''; setTimeout(function(){ st.textContent = msg; }, 50); }
  }
  function jzOpts() { return [].slice.call(searchResults.querySelectorAll('.jz-hdr__result')); }
  function jzMark() {
    jzOpts().forEach(function(a, i){ a.id = 'jz-so-opt-' + i; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false'); });
    jzActiveIdx = -1;
    searchInput.removeAttribute('aria-activedescendant');
  }
  function jzSetActive(i) {
    var o = jzOpts();
    if (!o.length) return;
    if (jzActiveIdx > -1 && o[jzActiveIdx]) { o[jzActiveIdx].classList.remove('is-active'); o[jzActiveIdx].setAttribute('aria-selected', 'false'); }
    jzActiveIdx = Math.max(0, Math.min(i, o.length - 1));
    var el = o[jzActiveIdx];
    el.classList.add('is-active');
    el.setAttribute('aria-selected', 'true');
    searchInput.setAttribute('aria-activedescendant', el.id);
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { e.preventDefault(); hideResults(); return; }
    if (searchResults.hidden) return;
    var o = jzOpts();
    if (e.key === 'ArrowDown' && o.length) { e.preventDefault(); jzSetActive(jzActiveIdx + 1); }
    else if (e.key === 'ArrowUp' && o.length) { e.preventDefault(); jzSetActive(jzActiveIdx - 1); }
    else if (e.key === 'Enter' && jzActiveIdx > -1 && o[jzActiveIdx]) { e.preventDefault(); e.stopImmediatePropagation(); window.location.assign(o[jzActiveIdx].href); }
  }, true);
})();
